module.exports = __webpack_public_path__ + "img/161.22ecbde4.jpg";